import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import baseURL from '../../url';

import { Link as Anchor } from "react-router-dom";
import storage from '../../storage';
import { colorTema } from '../../ThemeContext';
export default function Logout({ rol = 'admin', cajaAbierta = false }) {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            const response = await fetch(`${baseURL}/logout.php`, {
                method: 'GET',
                credentials: 'include',
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    storage.removeItem('adminUser');
                    toast.success(data.mensaje);
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else if (data.error) {
                    console.log(data.error);
                    toast.error(data.error);
                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(error.message);
        }
    };

    const confirmarSalida = (e) => {
        e.preventDefault();
        if (rol === 'trabajador' && cajaAbierta) {
            Swal.fire({
                title: 'No puedes salir',
                text: 'Tienes una caja abierta. Debes cerrarla antes de cerrar sesión.',
                icon: 'warning',
                confirmButtonText: 'Entendido',
                confirmButtonColor: colorTema(),
            });
            return;
        }
        Swal.fire({
            title: '¿Estás seguro de salir?',
            text: rol === 'trabajador'
                ? 'Se cerrará tu sesión de trabajador.'
                : 'Se cerrará tu sesión en el panel de administración.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, salir',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: colorTema(),
            cancelButtonColor: '#64748b',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                handleLogout();
            }
        });
    };

    return (
        <div>

            <Anchor onClick={confirmarSalida} className='btn'>
                <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '5px' }} />
                Salir
            </Anchor>
        </div>
    );
}
